export default __webpack_public_path__ + "static/media/payment.abc53f86.png";